(() => {
  const selector = '.cs27-hero-metrics strong, .csbz-hero-metrics strong, .csgb-hero-metrics strong';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const animations = new Set();
  function roll(element) {
    if (motion.matches || !element.animate || !/\d/.test(element.textContent)) return;
    const value = element.textContent;
    const fragment = document.createDocumentFragment();
    const reels = [];
    let digitIndex = 0;
    for (const character of value) {
      if (!/\d/.test(character)) {
        fragment.append(document.createTextNode(character));
        continue;
      }
      const digit = document.createElement('span');
      digit.className = 'cs-stat-digit';
      digit.setAttribute('aria-hidden', 'true');
      const reel = document.createElement('span');
      reel.className = 'cs-stat-reel';
      const stop = 20 + Number(character);
      for (let index = 0; index <= stop; index++) {
        const numeral = document.createElement('span');
        numeral.className = 'cs-stat-numeral';
        numeral.textContent = String(index % 10);
        reel.append(numeral);
      }
      reel.style.transform = `translateY(-${stop}em)`;
      digit.append(reel);
      fragment.append(digit);
      reels.push({ reel, stop, delay: digitIndex++ * 60 });
    }
    element.setAttribute('aria-label', value);
    element.replaceChildren(fragment);
    const pending = [];
    for (const { reel, stop, delay } of reels) {
      const animation = reel.animate([
        { transform: 'translateY(0)' },
        { transform: `translateY(-${stop}em)` }
      ], { duration: 1400, delay, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
      animations.add(animation);
      pending.push(animation.finished);
      animation.onfinish = () => animations.delete(animation);
      animation.oncancel = () => animations.delete(animation);
    }
    Promise.allSettled(pending).then(() => element.replaceChildren(document.createTextNode(value)));
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      roll(entry.target);
    }
  }, { threshold: .5 }) : null;
  function init(root) {
    for (const element of root.querySelectorAll(selector)) {
      if (seen.has(element)) continue;
      seen.add(element);
      if (observer) observer.observe(element);
    }
  }
  motion.addEventListener('change', () => {
    if (motion.matches) for (const animation of animations) animation.finish();
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
